<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import LaisModal from 'dashboard/components-next/LaisModal.vue';

defineProps({
  show: { type: Boolean, default: false },
  title: { type: String, default: '' },
  kind: { type: String, default: 'responsible' },
  canUpdateEntry: { type: Boolean, default: false },
});

const emit = defineEmits(['close', 'updateEntry', 'addMore']);
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <LaisModal
    :show="show"
    :title="title"
    max-width-class="max-w-[620px]"
    @close="emit('close')"
  >
    <div
      v-if="kind === 'responsible'"
      class="grid gap-3 text-[13px] leading-relaxed text-lais-text-body"
    >
      <p>
        Use este diálogo quando precisar saber quem deve destravar a visita:
        corretor, secretaria, proprietário, morador atual ou responsável por
        chaves.
      </p>
      <div class="grid gap-2 sm:grid-cols-3">
        <div class="rounded-lais-sm border border-lais-border px-3 py-3">
          <p class="font-semibold text-lais-text">Confirmar visita</p>
          <p class="mt-1 text-lais-text-muted">
            Cliente e imóvel têm dados suficientes para seguir.
          </p>
        </div>
        <div class="rounded-lais-sm border border-lais-border px-3 py-3">
          <p class="font-semibold text-lais-text">Visita não confirmada</p>
          <p class="mt-1 text-lais-text-muted">
            Falta confirmação de acesso, proprietário ou morador.
          </p>
        </div>
        <div class="rounded-lais-sm border border-lais-border px-3 py-3">
          <p class="font-semibold text-lais-text">Outros motivos</p>
          <p class="mt-1 text-lais-text-muted">
            Registre no cancelamento para manter histórico operacional.
          </p>
        </div>
      </div>
    </div>

    <div
      v-else-if="kind === 'learnMore'"
      class="grid gap-3 text-[13px] leading-relaxed text-lais-text-body"
    >
      <p>
        A visita usa as regras de disponibilidade do imóvel, do cliente e do
        corretor. Quando houver conflito, use reagendamento ou bloqueio de
        horários para evitar novas marcações no mesmo período.
      </p>
      <p
        class="rounded-lais-sm border border-lais-gold/40 bg-lais-gold/10 px-3 py-2"
      >
        Visitas geridas pelo proprietário precisam de confirmação explícita de
        entrada antes do envio da apresentação ao cliente.
      </p>
    </div>

    <div
      v-else
      class="grid gap-3 text-[13px] leading-relaxed text-lais-text-body"
    >
      <p>
        Quando não houver chaves disponíveis, copie o link do anúncio ou abra o
        imóvel para atualizar o campo de entrada. Assim o próximo agendamento já
        nasce com autorização correta.
      </p>
      <div class="flex flex-wrap gap-2">
        <button
          type="button"
          class="rounded-full border border-lais-border px-3 py-2 text-[12px] font-semibold text-lais-primary hover:border-lais-primary disabled:cursor-not-allowed disabled:opacity-50"
          :disabled="!canUpdateEntry"
          @click="emit('updateEntry')"
        >
          Atualizar entrada do imóvel
        </button>
        <button
          type="button"
          class="rounded-full border border-lais-border px-3 py-2 text-[12px] font-semibold text-lais-primary hover:border-lais-primary"
          @click="emit('addMore')"
        >
          Criar nova visita
        </button>
      </div>
    </div>
  </LaisModal>
</template>
